let ClientFeature = /*#__PURE__*/function (ClientFeature) {
  ClientFeature["OWN_CONTRACT"] = "OWN_CONTRACT";
  ClientFeature["BRANDED_EMAILS"] = "BRANDED_EMAILS";
  ClientFeature["VIP_SUPPORT"] = "VIP_SUPPORT";
  ClientFeature["USER_ANALYTICS"] = "USER_ANALYTICS";
  ClientFeature["SKIP_MANAGEMENT_FEE"] = "SKIP_MANAGEMENT_FEE";
  return ClientFeature;
}({});

export { ClientFeature };
//# sourceMappingURL=FeatureBehaviours.js.map
